/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { HealthResponse } from '../models/health-response';

/**
 * Spring boot actuator APIs
 */
@Injectable({ providedIn: 'root' })
export class ActuatorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `health()` */
  static readonly HealthPath = '/actuator/health';

  /**
   * checks if server is up.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `health()` instead.
   *
   * This method doesn't expect any request body.
   */
  health$Response(
    params?: {},
    context?: HttpContext
  ): Observable<StrictHttpResponse<HealthResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ActuatorService.HealthPath,
      'get'
    );
    if (params) {
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<HealthResponse>;
        })
      );
  }

  /**
   * checks if server is up.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `health$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  health(params?: {}, context?: HttpContext): Observable<HealthResponse> {
    return this.health$Response(params, context).pipe(
      map((r: StrictHttpResponse<HealthResponse>): HealthResponse => r.body)
    );
  }
}
